import styled from 'styled-components'

const FilterContainer = styled.div`
  background-color: ${(props) => props.theme.panelBgLight};
  padding: 16px;
`

export default FilterContainer
